import { storageRepository } from '@betgames/bg-tools';

export default class ABTests {
    private readonly TESTS = {
        TEST: 'TEST_NEW_INTEGRATION_2',
    };

    private readonly VARIATIONS = {
        ORIGINAL: 'original',
        VARIATION_1: 'Variation1',
        VARIATION_2: 'Variation2',
        VARIATION_3: 'Variation3',
    };

    private readonly matomoTests: Record<string, string> =
        storageRepository.getItemParsed('PiwikAbTesting');

    public get isNewIntegration(): boolean {
        const variation = this.matomoTests?.[`variation:${this.TESTS.TEST}`];
        return variation ? variation !== this.VARIATIONS.ORIGINAL : false;
    }
}

export const abTests = new ABTests();
